module.exports = __webpack_public_path__ + "static/media/reflexive_pronouns2_img.b4996edb.JPG";